import { Skeleton } from "@/components/ui/skeleton";

/** Platzhalter beim Nachladen von Listen – verhindert Layout-Sprünge. */
export function AdminSkeletonList({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-3" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="rounded-lg border border-border bg-background p-4">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="mt-3 h-3 w-2/3" />
        </div>
      ))}
    </div>
  );
}

/** Barrierefreier Ladehinweis (wird von Screenreadern vorgelesen). */
export function AdminLoading({ label = "Daten werden geladen …" }: { label?: string }) {
  return (
    <div>
      <p className="sr-only" role="status">
        {label}
      </p>
      <AdminSkeletonList />
    </div>
  );
}
